import React from 'react';
import NeighborsUserItem from './NeighborsUserItem';

const BlockedUserItem = ({ userItem, onUnblock }) => {
  return (
    <NeighborsUserItem
      userItem={userItem}
      primaryActionLabel="차단해제"
      onPrimaryAction={onUnblock}
    />
  );
};

export default BlockedUserItem;
